import { api } from '../../../services/api/apiClient';
import type { ApiResponse } from '../../../types/api';
import type { SiteContent } from '../types/websiteTypes';

export const siteContentService = {
  get: () => api.get<ApiResponse<SiteContent>>('/site-content').then((r) => r.data),
  update: (body: Partial<SiteContent>) => api.put<ApiResponse<SiteContent>>('/site-content', body).then((r) => r.data),
};
